import IndexSection from './Section'
import SectionPlaceholder from './SectionPlaceholder'
import YesNoDialog from './../../../zzl-vue-component/YesNoDialog'
import Draggable from 'vuedraggable'

export default {
	props: {
		value: {
			type: Object
		},
		coverSize: {
			type: String
		}
	},

	data() {
		const { sections } = this.value
		const { coverSize } = this
		return {
			maxSectionId: sections.reduce((max, sec) => max < sec.sectionId ? sec.sectionId : max, 0),
			removeConfirmActive: false,
			removeSectionIndex: null,
			removeSectionTitle: null,
			indexSectionOptions: {
				coverSize
			}
		}
	},

	components: {
		Draggable,
		IndexSection,
		SectionPlaceholder,
		YesNoDialog,
	},

	template: `
		<Draggable class="index-editor"
			v-model="value.sections"
			draggable=".index-section-sort"
			handle=".index-section-move-handle"
			chosen-class="index-section-chosen"
			ghost-class="index-section-ghost"
			:animation="250"
		>
			<div v-for="(section, index) in value.sections" :key="section.sectionId"
				class="index-section-wrap index-section-sort"
			>
				<IndexSection v-model="value.sections[index]" v-bind="indexSectionOptions" />
				<div class="index-section-move-handle" title="ドラッグで移動">
					<span class="glyphicon glyphicon-move" aria-label="ドラッグで移動"></span>
				</div>
				<div class="index-section-remove-btn" title="グループを削除"
					@click="removeSectionConfirm(index)"
				>
					<span class="glyphicon glyphicon-remove" aria-label="グループを削除"></span>
				</div>
			</div>
			<div class="index-section-wrap" ref="placeholder">
				<div @click="addSection()">
					<SectionPlaceholder />
				</div>
			</div>
			<YesNoDialog title="グループ削除"
				v-if="removeConfirmActive"
				@yes="removeSelectedSection"
				@no="removeConfirmActive = false"
			>
				グループ「{{removeSectionTitle}}」を削除してもよろしいですか？<br>
				グループに追加されたリンクもすべて削除されます。
			</YesNoDialog>
		</Draggable>
	`,

	methods: {
		addSection() {
			this.value.sections.push({
				sectionId: ++this.maxSectionId,
				title: '',
				cover: null,
				items: []
			})
		},
		removeSectionConfirm(index) {
			this.removeSectionIndex = index
			this.removeSectionTitle = this.value.sections[index].title
			this.removeConfirmActive = true
		},
		removeSelectedSection() {
			this.removeSection(this.removeSectionIndex)
			this.removeConfirmActive = false
		},
		removeSection(index) {
			this.value.sections.splice(index, 1)
		},
	}
}
